import { Injectable } from '@angular/core';
import * as mixpanel from 'mixpanel-browser';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root',
})
export class MixPanelService {
    constructor() {
        mixpanel.init(environment.mixpanel.token);
    }

    identify(id: string) {
        mixpanel.identify(id);
    }

    peopleSet(properties: any) {
        mixpanel.people.set(properties);
    }

    track(event: string, properties?: any) {
        if (mixpanelAllowedEvents.includes(event)) {
            mixpanel.track(event, properties);
        }
    }

    increment(event: string, properties?: any) {
        mixpanel.people.increment(event, properties);
    }

    reset() {
        mixpanel.reset();
    }
}

export const mixpanelAllowedEvents = [
    'register',
    'add_address',
    'view_cart',
    'begin_checkout',
    'add_payment_info',
    'purchase',
    'payment-failed',
];
